import Navbar from "@/components/Navbar";
import CinematicHero from "@/components/landing/CinematicHero";
import SaCagnotte from "@/components/landing/SaCagnotte";
import InteractiveTimeline from "@/components/landing/InteractiveTimeline";
import LiveMomentsFeed from "@/components/landing/LiveMomentsFeed";
import NewHowItWorksSection from "@/components/landing/NewHowItWorksSection";
import TrustSection from "@/components/landing/TrustSection";
import BirthDateCalculator from "@/components/BirthDateCalculator";
import EmotionalFooter from "@/components/landing/EmotionalFooter";

const New3Landing = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="new3" />
      <CinematicHero />
      <SaCagnotte />
      <InteractiveTimeline />
      <LiveMomentsFeed />
      <NewHowItWorksSection />
      <TrustSection />
      <BirthDateCalculator />
      <EmotionalFooter />
    </div>
  );
};

export default New3Landing;
